export const SEARCHRADIUS = 160000;
export const LIST = 'list';
export const ALL ='all';
export const POSITION = 'top-right';
export const AUTO = 'Auto';
export const GRAYSCALE_LIGHT = 'grayscale_light';
export const SUBSCRIPTION_KEY = 'subscriptionKey'
export const CENTER = 'center';
export const FLY = 'fly';
export const DURATION = 2000;
export const TEST_ID = 'test-map'
export const LATITUDE_VALUE = 38.8951;
export const LONGITUDE_VALUE = -77.0364;
export const htmlContent = `<div style="width:20px;height:20px;background-color:blue;border-radius:50%;border:3px solid white;box-shadow: 0 0 5px rgba(0,0,0,0.5);"></div>`;
